export const ROUTES = {
  HOME: "/",
  MATCH: (sessionId: string) => `/match/${sessionId}`,
  SHOP: "/shop",
  SHOP_SKINS: "/shop/skins",
  SHOP_GOLD_CARD: "/shop/gold-card",
  WALLET: "/wallet",
  WALLET_DEPOSIT: "/wallet/deposit",
  WALLET_WITHDRAW: "/wallet/withdraw",
  REFERRALS: "/referrals",
  REFERRALS_DETAILS: "/referrals/details",
  REFERRALS_COMMISSIONS: "/referrals/commissions",
  REFERRALS_FRIENDS: "/referrals/friends",
  QUESTS: "/quests",
  QUESTS_LIST: "/quests/quests"
} as const
